const STATS = [
  { id: "might", label: "Might", color: "#c0392b", description: "Strength, physical power. Damage reduces Current Might first. Each Modifier adds D4 to Large Weapons & Brawl." },
  { id: "speed", label: "Speed", color: "#2980b9", description: "Movement & dexterity. Each Modifier adds D4 to Small Weapons, +1 Movement, +1 Speed Checks." },
  { id: "intellect", label: "Intellect", color: "#8e44ad", description: "Social aptitude & information interpretation. Each Modifier adds +1 to Intellect Checks." },
  { id: "magic", label: "Magic", color: "#16a085", description: "Spellcasting resource. Every 5 Magic = 1 Magic Power die. Not a health stat — spent to cast spells." },
];

export default STATS
